import { PageGuideCard, type PageGuideCardProps } from './PageGuideCard';

export interface HelpEmptyStateProps {
  guide: Omit<PageGuideCardProps, 'onAsk'>;
  onAsk: (faqId: string) => void;
}

/** What ChatThread renders when there are no messages: the guide card in a 20px pad, top-aligned. */
export function HelpEmptyState({ guide, onAsk }: HelpEmptyStateProps) {
  return (
    <div className="p-5">
      <PageGuideCard {...guide} onAsk={onAsk} />
    </div>
  );
}
